














import { Component, Vue } from 'vue-property-decorator'
import Header from '@/components/propertyViewer/header/Header.vue'
import Main from '@/components/propertyViewer/Main.vue'
import LeadItemFull from '@/components/propertyViewer/LeadItemFull.vue'
import Feedback from '@/components/propertyViewer/Feedback.vue'

@Component({
  components: {
    'pv-header': Header,
    'pv-main': Main,
    LeadItemFull,
    Feedback
  }
})
export default class PropertyViewer extends Vue {
  get galleryImages () {
    return this.$store.getters.gallery?.images
  }

  get galleryIndex () {
    return this.$store.getters.gallery?.index
  }

  set galleryIndex (val: number) {
    this.$store.commit('setGalleryIndex', val)
  }

  get lead () {
    return this.$store.getters.lead || this.$store.getters.multipleLeads?.length
  }
}
